import Lenis from "@studio-freight/lenis";
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from 'splitting';

gsap.registerPlugin(ScrollTrigger);
const animations = {
    init()  {
        // Function to check if the current browser is Safari
        function isSafari() {
            return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        }
        if($('.hero .asset-row')[0]){
            positionDots();
        }

        // Reposition dots on window resize
        $(window).resize(function() {
            positionDots();
        });

        // Function to position '.dots' at the bottom of '.hero'
        function positionDots() {
            var heroBottom = $('.hero').offset().top + $('.hero').outerHeight();
            $('.dots').css('top', heroBottom + 'px');
        }

        // Check if the device is likely a mobile device based on screen width
        if (window.innerWidth <= 768) { // This width can be adjusted based on your definition of "mobile"
            setTimeout(function() {
                var video = document.querySelector('video');
                if (video) {
                    video.play().catch(error => console.error("Autoplay with play():", error));
                }
            }, 1000); // Adjust delay as needed
        }

        document.querySelectorAll('.masthead .menu > li > a').forEach(function(item) {
            item.addEventListener('mouseenter', function() {
                // This ensures that the item being hovered on remains fully opaque
                this.style.opacity = "1";
            });
            item.addEventListener('mouseleave', function() {
                // This resets the opacity to fully opaque when not hovered
                // It's not strictly necessary unless you want to change the opacity dynamically with JS
                this.style.opacity = "";
            });
        });
        function calculateOffset() {
            const tableHeaderHeight = document.querySelector('.table-header')?.offsetHeight || 0;
            return tableHeaderHeight; // Adding 32px to the header height
        }
        const tableHeader = document.querySelectorAll('.table-header');
        if(tableHeader.length > 0) {
            const tableHeaderHeight = document.querySelector('.table-header').offsetHeight;
            if (typeof tableHeaderHeight !== 'undefined') {
                const offset = calculateOffset();
                // const startOffset = offset + 150; // Increase the offset value by 100 (adjust this value as needed)

                gsap.utils.toArray('.table-body .table-row').forEach(element => {
                    console.log(element);
                    gsap.to(element, {
                        opacity: 0, // Fade out
                        ease: "none",
                        scrollTrigger: {
                            trigger: element,
                            start: `top-=${offset} top`, // Start fading after scrolling past offset
                            end: "bottom top",
                            onEnter: () => element.style.visibility = 'hidden', // Hide element when scrolling down
                            onLeaveBack: () => element.style.visibility = 'visible',
                            scrub: true, // Smooth scrubbing, adjust or remove if you want a sudden start/end
                            // toggleActions: "play none none reverse",
                        },
                    });
                });
            }

        }


        // Get all buttons with the class .button within .card
        const buttons = document.querySelectorAll('.card .button');
        // Check if buttons exist
        if (buttons.length > 0) {
            // Add event listeners to each button
            buttons.forEach(button => {
                button.addEventListener('mouseenter', function() {
                    // When mouse enters the button, add 'active' class to its parent .card
                    this.closest('.card').classList.add('active');
                });

                button.addEventListener('mouseleave', function() {
                    // When mouse leaves the button, remove 'active' class from its parent .card
                    this.closest('.card').classList.remove('active');
                });
            });
        }

        // Get all buttons with the class .button within .card
        const pagesListButtons = document.querySelectorAll('.pages-list a');
        // Check if buttons exist
        if (pagesListButtons.length > 0) {
            // Add event listeners to each button
            pagesListButtons.forEach(button => {
                button.addEventListener('mouseenter', function() {
                    // When mouse enters the button, add 'active' class to its parent .card
                    this.closest('.pages-list__content-column').classList.add('active');
                });

                button.addEventListener('mouseleave', function() {
                    // When mouse leaves the button, remove 'active' class from its parent .card
                    this.closest('.pages-list__content-column').classList.remove('active');
                });
            });
        }

        document.addEventListener("DOMContentLoaded", function() {


            // Apply the 'object-fit: unset' style if the browser is Safari
            if (isSafari()) {
                // Select both .framed img and .framed video elements
                document.querySelectorAll('.framed img, .framed video').forEach(function(element) {
                    console.log('element detected');
                    element.style.objectFit = 'cover';
                });
            }
        });


        // // Get all buttons with the class .button--icon within .solutions__page
        const buttonsSolutions = document.querySelectorAll('.book-demo-cta__inner .button');
        // Check if buttonsSolutions exist
        if (buttonsSolutions.length > 0) {
            // Add event listeners to each button
            buttonsSolutions.forEach(button => {
                button.addEventListener('mouseenter', function() {
                    // When mouse enters the button, add 'active' class to its parent .card
                    this.closest('.book-demo-cta__inner').classList.add('active');
                });

                button.addEventListener('mouseleave', function() {
                    // When mouse leaves the button, remove 'active' class from its parent .card
                    this.closest('.book-demo-cta__inner').classList.remove('active');
                });
            });
        }

        // Get all buttons with the class .button--icon within .solutions__page
        const categoryCard = document.querySelectorAll('.category-card .link');
        // Check if buttonsSolutions exist
        if (categoryCard.length > 0) {
            // Add event listeners to each button
            categoryCard.forEach(button => {
                button.addEventListener('mouseenter', function() {
                    // When mouse enters the button, add 'active' class to its parent .card
                    this.closest('.category-card').classList.add('active');
                });

                button.addEventListener('mouseleave', function() {
                    // When mouse leaves the button, remove 'active' class from its parent .card
                    this.closest('.category-card').classList.remove('active');
                });
            });
        }



        Splitting();
        const onLoadTitles = [...document.querySelectorAll('.on-load.title [data-splitting][data-effect6]')];
        const onScrollTitles = [...document.querySelectorAll('.on-scroll.title [data-splitting][data-effect6]')];


        // Initialize and use Lenis only if it's not Safari

            let lenis;
            lenis = new Lenis({
                duration: 0.8,
            });

            lenis.on('scroll', () => ScrollTrigger.update());

            function raf(time) {
                lenis.raf(time);
                requestAnimationFrame(raf)
            }

            requestAnimationFrame(raf);


        $('input[type="radio"][name="plan"]').change(function() {

            if($(this).val() == 'Annually'){
                $('.js-annual-price').show();
                $('.js-monthly-price').hide();
            }else{
                $('.js-annual-price').hide();
                $('.js-monthly-price').show();
            }
        })

        // document.querySelectorAll('.left-and-right-content__asset-column .image-wrapper').forEach((img) => {
        //
        //     console.log(img);
        //
        //     let imgHeight = img.offsetHeight; // Make sure this calculation is correct
        //     let endValue = `+=${imgHeight}`;
        //     gsap.to(img, {
        //         scrollTrigger: {
        //             trigger: img, // Adjusting to use .pages-list__asset-column as the trigger
        //             start: "top bottom",
        //             end: endValue,
        //             scrub: false,
        //             markers: true, // Uncomment if you want to see markers for debugging
        //         },
        //         scale: 1, // Target scale
        //         y: 0, // Translate to Y = 0
        //         ease: "none", // Use a linear ease for smooth scrubbing
        //     });
        // });

        // document.querySelectorAll('.pages-list__asset-column .image-wrapper').forEach((img) => {
        //     // Define default values for desktop
        //     let startValue = "top bottom";
        //     // let endValue = "bottom top";
        //     //
        //     // // Check if the viewport width is less than or equal to 768px for tablet
        //     // if (window.innerWidth <= 768) {
        //     //     startValue = "top top"; // Adjust as needed for tablet
        //     //     endValue = "bottom top"; // Adjust as needed for tablet
        //     // }
        //     //
        //     // // Further adjust if needed for mobile (you can choose another breakpoint if you like)
        //     // if (window.innerWidth <= 480) {
        //     //     startValue = "top top"; // Adjust as needed for mobile
        //     //     endValue = "bottom top"; // Adjust as needed for mobile
        //     // }
        //
        //     let imgHeight = img.offsetHeight;
        //     let endValue = `+=${imgHeight}`;
        //
        //     gsap.to(img, {
        //         scrollTrigger: {
        //             trigger: img, // Adjusting to use .pages-list__asset-column as the trigger
        //             start: startValue,
        //             end: endValue,
        //             scrub: false,
        //             // markers: true, // Uncomment if you want to see markers for debugging
        //         },
        //         scale: 1, // Target scale
        //         y: 0, // Translate to Y = 0
        //         ease: "none", // Use a linear ease for smooth scrubbing
        //     });
        // });

        $('.search-field').on('click', function() {
            var defaultValue = "Search our articles"; // The default value
            if ($(this).val() === defaultValue) {
                $(this).val(''); // Clear the value
            }
        });

        if (window.innerWidth >= 1024) {
            document.querySelectorAll('#tableHeader').forEach((stickyElement) => {
                ScrollTrigger.create({
                    trigger: stickyElement,
                    start: "top top", // Adjusted to start pinning right at the top
                    endTrigger: stickyElement.parentNode,
                    end: "bottom top",
                    pin: true,
                    pinSpacing: false,
                    // markers: true, // For debugging
                    onEnter: () => stickyElement.style.transform = "translateY(32px)", // Push down when pinned
                    onLeaveBack: () => stickyElement.style.transform = "", // Reset when unpinned
                });
            });
        }


        // document.querySelectorAll('.hero .framed').forEach((img) => {
        //     // Define default values for desktop
        //     let startValue = "top top";
        //     let endValue = "bottom top";
        //
        //     // Check if the viewport width is less than or equal to 768px for tablet
        //     if (window.innerWidth <= 768) {
        //         startValue = "top top"; // Adjust as needed for tablet
        //         endValue = "bottom top"; // Adjust as needed for tablet
        //     }
        //
        //     // Further adjust if needed for mobile (you can choose another breakpoint if you like)
        //     if (window.innerWidth <= 480) {
        //         startValue = "top top"; // Adjust as needed for mobile
        //         endValue = "bottom top"; // Adjust as needed for mobile
        //     }
        //     gsap.to(img, {
        //         scrollTrigger: {
        //             trigger: img.closest('.hero'), // Now using .hero as the trigger
        //             start: startValue,
        //             end: endValue,
        //             scrub: false,
        //             // markers: true,
        //         },
        //         scale: 1, // Target scale
        //         ease: "none", // Use a linear ease for smooth scrubbing
        //     });
        // });
        //
        // document.querySelectorAll('.hero .asset').forEach((img) => {
        //     // Define default values for desktop
        //     let startValue = "top top";
        //     let endValue = "bottom top";
        //
        //     // Check if the viewport width is less than or equal to 768px for tablet
        //     if (window.innerWidth <= 768) {
        //         startValue = "top top"; // Adjust as needed for tablet
        //         endValue = "bottom top"; // Adjust as needed for tablet
        //     }
        //
        //     // Further adjust if needed for mobile (you can choose another breakpoint if you like)
        //     if (window.innerWidth <= 480) {
        //         startValue = "top top"; // Adjust as needed for mobile
        //         endValue = "bottom top"; // Adjust as needed for mobile
        //     }
        //     gsap.to(img, {
        //         scrollTrigger: {
        //             trigger: img.closest('.hero'), // Now using .hero as the trigger
        //             start: startValue,
        //             end: endValue,
        //             scrub: false,
        //             // markers: true,
        //         },
        //         scale: 1, // Target scale
        //         ease: "none", // Use a linear ease for smooth scrubbing
        //     });
        // });

        $('.mobile-menu').on('click', '.menu-item-has-children > a', function(e){
            e.preventDefault();
            $(this).parent().toggleClass('active');
        })

        var $smallImage = $('.secondary-asset');
        var smallImageHeight = $smallImage.outerHeight(); // Includes any border or padding

        var $framed = $('.asset-wrapper .framed');
        var framedPaddingBottom = parseInt($framed.css('padding-bottom')); // Get the bottom padding of the framed element

        // Calculate the bottom position of the small image, half outside the frame
        var bottomPosition = -(smallImageHeight / 2) + framedPaddingBottom;

        // Set the calculated bottom position
        $smallImage.css('bottom', bottomPosition);

        $('.pages-list .image-wrapper').each(function() {
            // For each '.image-wrapper', find the '.secondary-asset' within it
            var $smallImage = $(this).find('.supporting-image');
            var smallImageHeight = $smallImage.outerHeight(); // Includes any border or padding

            // Also, find the '.framed' element within the current '.image-wrapper'
            var $framed = $(this).find('.framed--tight');
            var framedPaddingBottom = parseInt($framed.css('padding-bottom'), 10); // Get the bottom padding of the framed element

            // Calculate the bottom position of the small image, half outside the frame
            var bottomPosition = -(smallImageHeight / 2) + framedPaddingBottom;

            // Set the calculated bottom position for this '.secondary-asset'
            $smallImage.css('bottom', bottomPosition);
        });




        // Animation on load
        const onLoadAnimation = () => {
            // if (window.innerWidth < 768) {
            //     // If the screen is narrower than 768px, exit the function early.
            //     return;
            // }
            onLoadTitles.forEach(title => {
                // Optionally set perspective for the title for any added depth effects (optional)
                gsap.set(title, {perspective: 2000});

                // Directly animate each title with a fade-in and slight upward motion
                gsap.fromTo(title, {
                    // Starting state of the animation
                    opacity: 0,
                    y: 50 // Adjust this value to control the starting vertical offset
                }, {
                    // Ending state of the animation

                    opacity: 1,
                    y: 0, // Aligns with the title's natural position
                    ease: 'power1.out', // Adjust the easing to change the animation feel
                });
            });
        };

        onLoadAnimation();
        const headerHeight = $('.masthead').outerHeight();
        let lastScrollTop = 0;
        $(window).scroll(function() {
            let st = $(this).scrollTop();

            if (st > lastScrollTop) {
                // Scrolling down
                if (st > headerHeight) {
                    // Only add scrolling-down class if we've scrolled past the header
                    $('.masthead').addClass('scrolling-down').removeClass('sticky');
                }
            } else {
                // Scrolling up
                if (st > 0) {
                    // Add sticky class only if not at the top (st > 0)
                    $('.masthead').addClass('sticky');
                } else {
                    // Remove sticky class when at the top
                    $('.masthead').removeClass('sticky');
                }
                $('.masthead').removeClass('scrolling-down');
            }
            lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        });

        // const scroll = () => {
        //     // if (window.innerWidth < 768) {
        //     //     // If the screen is narrower than 768px, exit the function early.
        //     //     return;
        //     // }
        //     onScrollTitles.forEach(title => {
        //         // Apply perspective to the title if desired for additional effects (optional)
        //         gsap.set(title, {perspective: 2000});
        //
        //         // Animate titles with a simple fade-in and upward motion
        //         gsap.fromTo(title, {
        //             // Initial state before the animation
        //             opacity: 0,
        //             y: 70 // Adjust this value to control the starting position of the upward motion
        //         }, {
        //             // Final state to achieve after the animation
        //             opacity: 1,
        //             y: 0, // Ensures the title ends at its natural position
        //             ease: 'power1.out', // Adjust the easing function to suit the desired animation feel
        //             scrollTrigger: {
        //                 scrub: 1,
        //                 trigger: title,
        //                 start: 'top bottom+=40%',
        //                 end: 'top center-=30%',
        //                 // markers: true, // Uncomment if you want to see trigger markers for debugging
        //             }
        //         });
        //     });
        // }
        //
        // scroll();

        // var footerHeight = document.querySelector('.mastfoot').offsetHeight; // Get the footer's height
        // var dots = document.querySelectorAll('.backgrounds .dots'); // Get all the .dots elements within .backgrounds
        //
        // dots.forEach(function(dot) {
        //     dot.style.position = 'absolute'; // Ensure .dots are positioned absolutely relative to a positioned ancestor
        //     dot.style.bottom = footerHeight + 'px'; // Set the bottom property to the height of the footer
        // });

        $('.js-mobile-menu-trigger').on('click', function(){
            $(this).toggleClass('active');
            // Toggle the 'active' class to open or close the menu
            $('.mobile-menu').toggleClass('active');
            $('body').toggleClass('active');
            $('html').toggleClass('active');

            // Check if the menu is now open (has the 'active' class)
            if ($('.mobile-menu').hasClass('active')) {
                // The menu is open, so stop Lenis to allow scrolling within the menu
                lenis.destroy();
            } else {
                // The menu is closed, so start Lenis for smooth scrolling on the page
                lenis.start();
            }
        })

        // Function to scroll to an element
        const scrollToElement = (target) => {
            const targetElement = document.querySelector(target)
            if (!targetElement) return

            const targetPosition = targetElement.getBoundingClientRect().top + lenis.scroll.scrollY
            lenis.scrollTo(targetPosition, 1000) // Smoothly scroll to target
        }

        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();

                const targetId = this.getAttribute('href');
                const targetElement = document.querySelector(targetId);

                if (targetElement) {
                    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });

        $('#planSelect').on('change', function(){
            $('.table-body').addClass('active');
            var row = parseInt($(this).val()) + 1;
            $('.table-body .table-row [data-row]').hide();
            $('.table-body .table-row [data-row="'+ row +'"]').show();
        })



        $('.masthead .menu-item-has-children').hover(
            function() {
                // Stop any ongoing animation within the submenu
                var submenu = $(this).find('.sub-menu');
                submenu.stop(true, true).addClass('sub-menu-active');

                // // Animate each list item's opacity and translateY
                // submenu.find('li').each(function(i) {
                //     $(this).animate({
                //         opacity: 1,
                //         marginTop: '0px' // Move up to its original position
                //     });
                // });
            },
            function() {
                // When hovering out, immediately hide the submenu items and remove active class
                var submenu = $(this).find('.sub-menu');
                // submenu.find('li').stop(true, true).css({
                //     opacity: 0,
                //     // transform: 'translateY(-60px)' // Reset to initial lower position
                // });
                submenu.removeClass('sub-menu-active');
            }
        );

        // document.addEventListener('DOMContentLoaded', function() {
        //     var canvas = document.getElementById('noiseCanvas');
        //     var ctx = canvas.getContext('2d');
        //
        //     function resizeCanvas() {
        //         canvas.width = window.innerWidth;
        //         canvas.height = window.innerHeight;
        //         generateNoise();
        //     }
        //
        //     function generateNoise() {
        //         var imageData = ctx.createImageData(canvas.width, canvas.height);
        //         var data = imageData.data;
        //         var particleDensity = 0.02; // Lower density of noise particles
        //         var particleSize = 1; // Size of each particle. For finer noise, use 1.
        //
        //         // Clear the canvas
        //         ctx.clearRect(0, 0, canvas.width, canvas.height);
        //
        //         // Generate noise particles
        //         for (let i = 0; i < canvas.width * canvas.height * particleDensity; i++) {
        //             let x = Math.floor(Math.random() * canvas.width);
        //             let y = Math.floor(Math.random() * canvas.height);
        //             let index = (x + y * imageData.width) * 4;
        //
        //             let color = Math.floor(Math.random() * 255); // Grayscale color
        //             data[index] = color;     // Red
        //             data[index + 1] = color; // Green
        //             data[index + 2] = color; // Blue
        //             data[index + 3] = 255;   // Alpha (fully opaque)
        //         }
        //
        //         ctx.putImageData(imageData, 0, 0);
        //     }
        //
        //     resizeCanvas();
        //     window.addEventListener('resize', resizeCanvas);
        // });
    }
}

export {animations}